import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { easeOut, motion } from 'framer-motion';

import { Container, Row, Col, Button, Form,  Offcanvas, Image, Spinner } from 'react-bootstrap';

import alx from '../assets/alx.svg';
import andela from '../assets/andela.svg';
import google from '../assets/google.svg';


import { ExternalLink } from 'react-external-link';
// import { Link } from 'react-router-dom';
import './footer.css'

function Footer() {

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  const [isLoading, setIsLoading] = useState(false);


  const [fullname, setFullname] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [isValidEmail, setIsValidEmail] = useState(true);
  const navigate = useNavigate();

  const handleFullnameChange = (event) => {
    setFullname(event.target.value);
  };

   function getYearsOfExperience() {
  const startYear = 2020; // Change this to your actual starting year
  const currentYear = new Date().getFullYear();
  return currentYear - startYear;
}


  const handleChange = (event) => {
    const inputValue = event.target.value;
    setEmail(inputValue);
    setIsValidEmail(validateEmail(inputValue));
  };

  const handleMessageChange = (event) => {
    setMessage(event.target.value);
  };

  const validateEmail = (input) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(input);
  };



  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isValidEmail) {
      setIsLoading(true);
      try {
        await axios.post(
          'https://formspree.io/f/xknlwkza',
          { fullname, email, message }
        );

        // Close the modal
        handleClose();


        // Redirect to thank you page
        navigate('/formsubmission', { replace: true }); // Replace with your thank you page route


      } catch (error) {
        // Handle form submission error
      }
      finally {
        setIsLoading(false);
      }
    } else {
      alert('Please enter a valid email address.');
    }
   
  };

 

  
  return (
    <Container fluid  className="Bottomnav" >
    <Row>
      <Col  sm={12} md={12} lg={5} xl={5}>
        <div>
          <p className="bottomparagraph">
          I'm a creatively driven and versatile product designer committed to crafting exceptional and functional products with great user experiences. With over {getYearsOfExperience()} years of experience, I've contributed to the development of both enterprise and consumer-facing products.
          </p>
        </div>
        <div style={{ marginTop: 1.1 + "rem" ,display: 'flex', flexWrap: 'wrap', gap: '1rem'}}>
                       <ExternalLink
                         style={{ textDecoration: "none", Color: "black" }}
                         href="https://www.linkedin.com/in/akinseye-oluwasegun-yinka-319a661a9/"
                       >
                         <span
                           style={{
                            
                             color: "black",
                             fontWeight: "400",
                              fontFamily: 'Jost, sans-serif',
                              fontSize: "0.75rem",
                           }}
                         >
                           LINKEDIN
                         </span>
                       </ExternalLink>
       
                      
       
                       <ExternalLink
                         style={{ textDecoration: "none", Color: "black" }}
                         href="https://github.com/olayinka02"
                       >
                         <span
                           style={{
                           
                             color: "black",
                             fontWeight: "400",
                              fontFamily: 'Jost, sans-serif',
                               fontSize: "0.75rem",
                           }}
                         >
                           GITHUB
                         </span>
                       </ExternalLink>
       
                       <ExternalLink
                         style={{ textDecoration: "none", Color: "black" }}
                         href="https://www.instagram.com/0layimmika/"
                       >
                         <span
                           style={{
                            
                             color: "black",
                             fontWeight: "400",
                              fontFamily: 'Jost, sans-serif',
                               fontSize: "0.75rem",
                           }}
                         >
                           INSTAGRAM
                         </span>
                       </ExternalLink>
       
                       <ExternalLink
                         style={{ textDecoration: "none", Color: "black" }}
                         href="https://x.com/Olayimika_yinka"
                       >
                         <span
                           style={{
                            
                             color: "black",
                             fontWeight: "400",
                              fontFamily: 'Jost, sans-serif',
                               fontSize: "0.75rem",
                           }}
                         >
                           X
                         </span>
                       </ExternalLink>
       
                       
                     </div>
        <br /><br/>
      </Col>
      <Col  sm={12} md={12} lg={2} xl={2}></Col>
      <Col  sm={12} md={12} lg={5} xl={5}>
        <Row>
        <Col  >
       
             <div>

                
                <h4
                  style={{
                    color: "#000000",
                    fontSize: 0.9 + "rem",
                    fontWeight: "600",
                     fontFamily: 'Jost, sans-serif'
                  }}
                >
                  CERTIFICATE  
                </h4>
             
                <div fluid style={{display:'flex',flexWrap:'wrap' ,gap:1+'rem',width:100+'%'}} >
                <ExternalLink
                  href="https://intranet.alxswe.com/certificates/XJZ2RMhBpG"
                >
                  <Image src={alx} />
                  </ExternalLink>

                  <ExternalLink
                  href="https://credsverse.com/credentials/69223c11-efcc-43f9-b719-466fa0f5eff1"
                >
                  <Image src={andela} />
                  </ExternalLink>

                  <ExternalLink
                  href="https://www.coursera.org/account/accomplishments/specialization/certificate/LEW55QBFEXK3"
                >
                  <Image src={google} />
                  </ExternalLink>
                </div>
                
            
            </div>
        </Col>
          
       

        
        </Row>
      </Col>
    </Row>
    <br /><br/>

    <Row>
      <Col className="f1" sm={12} md={12} lg={5} xl={5}>
        <div>
          <p className="bottomparagraph">
          Do you want to say hi? Do you have a project to discuss with me? Let's grab a coffee.
          </p>

          <Button className='footercontactbtn'  variant="dark" style={{borderRadius:0+"rem"}} onClick={handleShow} >
            <span style={{ fontFamily: 'Jost, sans-serif', fontSize:0.8+'rem',marginLeft:0.5+"rem",marginRight:0.5+"rem"}}>
              CONTACT ME
            </span>
           
        </Button>

        </div>
      </Col>
      <Col sm={12} md={12} lg={2} xl={2}></Col>

      <Col className="f1" sm={12} md={12} lg={5} xl={5}>
        <div className="newsletterformbody">
          <h6  className="newsletterhead">Join Newsletter</h6>
          <div
            style={{
              display: "flex",
              backgroundColor: "black",
              borderRadius: 0 + "PX",
              padding:1+'px',
            }}
          >
            <Form.Control
              style={{
                height: 2.7 + "rem",
                 fontFamily: 'Jost, sans-serif'
,                fontSize: 0.85 + "rem",
                borderRadius: 0 + "PX",
              }}
              type="email"
              placeholder="Enter your mail here"
            />
            <Button
              style={{
                height: 2.7 + "rem",
                marginTop: 0 + "rem",
                 fontFamily: 'Jost, sans-serif',
                fontSize:0.83+"rem",
                backgroundColor: "#000000",
                borderRadius: 0 + "PX",
                paddingLeft: 1.2 + "rem",
                paddingRight: 1.2 + "rem",
              }}
              variant="primary"
              className="button-store"
              type="submit"
            >
              Subscribe
            </Button>
          </div>
          <p
            className="newsletterparagraph"
            style={{ marginTop: 0.7 + "rem", fontFamily: 'Jost, sans-serif',fontSize:0.8+"rem" }}
          >
            *I Will send you updates for your better engagement.
          </p>
        </div>
      </Col>

      <div style={{marginTop:-2+'rem'}}>
        <span style={{fontSize:0.85+'rem'}}><span>Design & Dev by:</span> Olayimika</span>
      </div>
    </Row>



    <Offcanvas placement='bottom' show={show} onHide={handleClose} className="contactmodal">
       
        <Offcanvas.Header closeButton closeVariant='white' >
          <Offcanvas.Title style={{ fontSize: 0.7 + 'rem', color: '#707070', fontFamily: 'Jost, sans-serif' }}>CONTACT ME</Offcanvas.Title>

        </Offcanvas.Header>
        <Offcanvas.Body>
          <div>
            <motion.div initial={{ opacity: 0, y: 20, }} animate={{ opacity: 1, y: -2, }} transition={{ duration: 0.3, delay: 0.2, timingFunction: easeOut }}>
              <h2 style={{ color: 'whitesmoke', fontWeight: 'bold',  fontFamily:"Clash Display" }}>
                Get in touch with me
              </h2>
              <p style={{ color: '#FFFFFF',  fontFamily: 'Jost, sans-serif' ,fontSize:0.8+"rem"}}>Provide the following details </p>
            </motion.div>

            <Form onSubmit={handleSubmit} style={{ fontFamily: 'Jost, sans-serif', fontSize:0.8+"rem"}} >
              <motion.div initial={{ opacity: 0, y: 20, }} animate={{ opacity: 1, y: -2, }} transition={{ duration: 0.3, delay: 0.4, timingFunction: easeOut }}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label style={{ color: '#FFFFFF' }}>Fullname</Form.Label>
                  <Form.Control
                   style={{borderRadius:0+"rem"}}
                    type="text"
                    value={fullname}
                    onChange={handleFullnameChange}
                    required
                    placeholder="Enter your fullname" />
                </Form.Group>
              </motion.div>

              <motion.div initial={{ opacity: 0, y: 20, }} animate={{ opacity: 1, y: -2, }} transition={{ duration: 0.3, delay: 0.6, timingFunction: easeOut }}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                  <Form.Label style={{ color: '#FFFFFF' }}>Email</Form.Label>
                  <Form.Control
                   style={{borderRadius:0+"rem"}}
                    type="email"
                    value={email}
                    onChange={handleChange}
                    required
                    placeholder="Enter your mail" />
                </Form.Group>

              </motion.div>

              <motion.div initial={{ opacity: 0, y: 20, }} animate={{ opacity: 1, y: -2, }} transition={{ duration: 0.3, delay: 0.8, timingFunction: easeOut }}>
                <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                  <Form.Label style={{ color: '#FFFFFF' }}>Message</Form.Label>
                  <Form.Control as="textarea"
                    style={{borderRadius:0+"rem"}}
                    value={message}
                    onChange={handleMessageChange}
                    required
                    placeholder="Enter your message" rows={3} />
                </Form.Group><br />
              </motion.div>

              <motion.div initial={{ opacity: 0, y: 20, }} animate={{ opacity: 1, y: -2, }} transition={{ duration: 0.3, delay: 0.95, timingFunction: easeOut }}>

                <Button type='submit' className="submitbtn" 


 style={{
                paddingLeft: "2rem",
                paddingRight: "2rem",
                fontFamily: "Jost, sans-serif",
              
                borderRadius: "0rem",

                  background:
                      "radial-gradient(70.4% 63.2% at 53.1% 128.2%, rgba(255, 255, 255, 0.23) 0%, rgba(255, 255, 255, 0.04) 100%)",
                    height: "100%",
                  
                    boxShadow:
                      "rgba(255, 255, 255, 0.024) 0px 0.362176px 0.651917px -1px inset, rgba(255, 255, 255, 0.035) 0px 3px 5.4px -2px inset",
                    willChange: "auto",
                    opacity: 1,
                    borderBottomWidth: "2px",
                    borderLeftWidth: "2px",
                    borderRightWidth: "2px",
                    borderTopWidth: "2px",
                    borderColor: "rgba(255, 255, 255, 0.02)",
                    borderStyle: "solid",
              }}                
                variant="dark"   disabled={isLoading} >
                {isLoading ? (
                <>
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                  <span
                    style={{
                      fontSize: 0.8 + "rem",
                      marginLeft: 0.3 + "rem",
                      marginRight: 0.3 + "rem",
                    }}
                  >
                    Loading...
                  </span>
                </>
              ) : (
                <span
                  style={{
                    fontSize: 0.8 + "rem",
                    marginLeft: 0.3 + "rem",
                    marginRight: 0.3 + "rem",
                  }}
                >
                  SUBMIT
                </span>
              )}
                </Button>


              </motion.div>
            </Form>

          </div>

        </Offcanvas.Body>
      </Offcanvas>
  </Container>
  )
}

export default Footer
